import { Phone, Instagram, MapPin, Code2 } from "lucide-react";
import { Logo } from "./Logo";
import { BRAND, SLOGAN, PHONE_DISPLAY, PHONE_TEL, INSTAGRAM_HANDLE, INSTAGRAM_URL, ADDRESS, MAP_LINK, NAV, SERVICES, AGENCY } from "@/data/site";

export const Footer = () => (
  <footer className="relative bg-grad-dark grain text-white pt-20 pb-10" data-testid="footer">
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo light className="h-20 sm:h-24" />
          <p className="mt-6 text-2xl font-semibold text-gradient-light tracking-tight">{SLOGAN}</p>
          <p className="mt-4 text-sm leading-relaxed text-pink-100/70 max-w-sm">Esenyurt güzellik salonu: protez tırnak, manikür, pedikür, ipek kirpik ve cilt bakımı hizmetlerinde premium deneyim.</p>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs tracking-[0.2em] uppercase text-pink-200/60">Menü</p>
          <ul className="mt-5 space-y-3">{NAV.map((n) => <li key={n.href}><a href={n.href} className="text-sm text-pink-100/80 hover:text-white transition-colors">{n.label}</a></li>)}</ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs tracking-[0.2em] uppercase text-pink-200/60">Hizmetler</p>
          <ul className="mt-5 space-y-3">{SERVICES.map((s) => <li key={s.id}><a href="#hizmetler" className="text-sm text-pink-100/80 hover:text-white transition-colors">{s.name}</a></li>)}</ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.2em] uppercase text-pink-200/60">İletişim</p>
          <ul className="mt-5 space-y-4 text-sm">
            <li><a href={PHONE_TEL} data-testid="footer-phone-link" className="flex items-center gap-3 text-pink-100/80 hover:text-white transition-colors"><Phone size={16} className="text-[#ff5fa8]" />{PHONE_DISPLAY}</a></li>
            <li><a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="flex items-center gap-3 text-pink-100/80 hover:text-white transition-colors"><Instagram size={16} className="text-[#ff5fa8]" />{INSTAGRAM_HANDLE}</a></li>
            <li><a href={MAP_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-address-link" className="flex items-start gap-3 text-pink-100/80 hover:text-white transition-colors"><MapPin size={16} className="text-[#ff5fa8] mt-0.5 shrink-0" />{ADDRESS}</a></li>
          </ul>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-pink-100/50">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} {BRAND}. Tüm hakları saklıdır.</p>
        <a href={AGENCY.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-agency-link" className="group inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 hover:bg-white/10 hover:border-[#ff5fa8]/50 transition-colors">
          <Code2 size={14} className="text-[#ff5fa8]" />
          <span>{AGENCY.label}:</span>
          <span className="font-semibold text-white group-hover:text-gradient-light">{AGENCY.name}</span>
        </a>
      </div>
    </div>
  </footer>
);
